import { ButtonType } from 'src/types/blocks'
import './style.scss'

interface Props {
  clickHandler?: () => void
  children: React.ReactElement | React.ReactNode | string
  cn?: string
  buttonType?: ButtonType
}

const Button = ({
  clickHandler,
  children,
  cn = '',
  buttonType = 'primary',
}: Props) => {
  return (
    <button
      className={`nextroundBtn nextroundBtn__${buttonType} ${cn}`}
      onClick={clickHandler}
    >
      {children}
    </button>
  )
}

export default Button
